import { ThemeElevenHeader, ThemeThreeHeader, ThemeTwoHeader } from '../..';

import Header1 from './Header1';
import Header2 from './Header2';
import Header6 from './Header6';
import React from 'react';
import ThemeFourHeader from '../../ThemeFour/common/ThemeFourHeader';
import ThemeSevenHeader from '../../ThemeSeven/common/ThemeSevenHeader';
import ThemeEightHeader from '../../ThemeEight/common/ThemeEightHeader';
import ThemeNineHeader from '../../ThemeNine/common/ThemeNineHeader';

// import Header3 from './Header3';
// Header5  is for saopaulo for info
// import { Header5 } from './Header5';

const MainHeader = ({ history, operator, loginData, onMyAccountClick, t }) => {
  // ----------------
  // console.log("operator in mainheader---",operator)
  const getHeader = () => {
    const themeType = operator && operator.theme_type && operator.theme_type;
    if (themeType === 1 || themeType === 10) {
      return <Header1
        history={history}
        operator={operator}
        loginData={loginData}
        t={t}
        onMyAccountClick={onMyAccountClick} />;
    } else if (themeType === 2) {
      return <ThemeTwoHeader
        history={history}
        operator={operator}
        loginData={loginData}
        t={t}
        onMyAccountClick={onMyAccountClick}
      />;
    } else if (themeType === 3) {
      return <ThemeThreeHeader
        history={history}
        operator={operator}
        loginData={loginData}
        t={t}
        onMyAccountClick={onMyAccountClick}
      />;
    } else if (themeType === 5) {
      return (
        <Header2
          history={history}
          operator={operator}
          loginData={loginData}
          t={t}
          onMyAccountClick={onMyAccountClick}
        />
      );
    } else if (themeType === 6) {
      return <Header6
        history={history}
        operator={operator}
        loginData={loginData}
        t={t}
        onMyAccountClick={onMyAccountClick}
      />;
    } else if (themeType === 7) {
      return <ThemeSevenHeader
        history={history}
        operator={operator}
        loginData={loginData}
        t={t}
        onMyAccountClick={onMyAccountClick}
      />;
    } else if (themeType === 4) {
      return <ThemeFourHeader
        history={history}
        operator={operator}
        loginData={loginData}
        t={t}
        onMyAccountClick={onMyAccountClick}
      />;
    } else if (themeType === 8) {
      return <ThemeEightHeader
        history={history}
        operator={operator}
        loginData={loginData}
        t={t}
        onMyAccountClick={onMyAccountClick}
      />;
    }else if (themeType === 9) {
      return <ThemeNineHeader
        history={history}
        operator={operator}
        loginData={loginData}
        t={t}
        onMyAccountClick={onMyAccountClick}
      />;
    }
    else if (themeType === 11) {
      return <ThemeElevenHeader
        history={history}
        operator={operator}
        loginData={loginData}
        t={t}
        onMyAccountClick={onMyAccountClick}
      />;
    }
    return <div />;
    
  };
  return <React.Fragment>{getHeader()}</React.Fragment>;
};

export default MainHeader;



// WEBPACK FOOTER //
// ./src/features/themes/common/header/MainHeader.js